// API calls for the broker dashboard: listings CRUD, leads, stats, and image uploads.
import { brokerSessionStorage } from "./brokerSession.storage";

const BASE_URL = `${process.env.REACT_APP_API_BASE}/api`;

const authHeaders = () => ({
    Authorization: `Bearer ${brokerSessionStorage.get()}`,
});

const handle = async (res, fallbackMessage) => {
    let data;
    try { data = await res.json(); } catch { data = {}; }
    if (!res.ok) throw new Error(data.error || fallbackMessage);
    return data;
};

export const getMyProperties = async () => {
    const res = await fetch(`${BASE_URL}/broker/properties`, {
        headers: authHeaders(),
    });
    return handle(res, "Failed to load your listings.");
};

export const createMyProperty = async (payload) => {
    const res = await fetch(`${BASE_URL}/broker/properties`, {
        method: "POST",
        headers: { "Content-Type": "application/json", ...authHeaders() },
        body: JSON.stringify(payload),
    });
    return handle(res, "Failed to create listing.");
};

export const updateMyProperty = async (id, payload) => {
    const res = await fetch(`${BASE_URL}/broker/properties/${id}`, {
        method: "PUT",
        headers: { "Content-Type": "application/json", ...authHeaders() },
        body: JSON.stringify(payload),
    });
    return handle(res, "Failed to update listing.");
};

export const deleteMyProperty = async (id) => {
    const res = await fetch(`${BASE_URL}/broker/properties/${id}`, {
        method: "DELETE",
        headers: authHeaders(),
    });
    if (!res.ok) {
        let data;
        try { data = await res.json(); } catch { data = {}; }
        throw new Error(data.error || "Failed to delete listing.");
    }
};

export const setMyPropertyVisibility = async (id, active) => {
    const res = await fetch(`${BASE_URL}/broker/properties/${id}/visibility?active=${active}`, {
        method: "PATCH",
        headers: authHeaders(),
    });
    return handle(res, "Failed to update listing visibility.");
};

export const getMyLeads = async () => {
    const res = await fetch(`${BASE_URL}/broker/leads`, {
        headers: authHeaders(),
    });
    return handle(res, "Failed to load your leads.");
};

export const getMyDashboardStats = async () => {
    const res = await fetch(`${BASE_URL}/broker/dashboard-stats`, {
        headers: authHeaders(),
    });
    return handle(res, "Failed to load dashboard stats.");
};

export const uploadPropertyImage = async (propertyId, file) => {
    const formData = new FormData();
    formData.append("file", file);
    const res = await fetch(`${BASE_URL}/properties/${propertyId}/upload-image`, {
        method: "POST",
        headers: authHeaders(),
        body: formData,
    });
    if (!res.ok) throw new Error("Failed to upload image.");
    return res.text();
};

export const uploadPropertyImages = async (propertyId, files) => {
    const formData = new FormData();
    files.forEach((file) => formData.append("files", file));
    const res = await fetch(`${BASE_URL}/properties/${propertyId}/upload-images`, {
        method: "POST",
        headers: authHeaders(),
        body: formData,
    });
    if (!res.ok) throw new Error("Failed to upload images.");
    return res.json();
};
